module.exports = __webpack_public_path__ + "static/SatoWallet-f38587fa728593b76a6126e56946abe8.png";